/* FSL highlight text on scroll.

   Sumber pola: Osmo Supply "Highlight Text On Scroll". Tiap huruf berangkat
   dari opacity rendah lalu penuh, di-scrub mengikuti scroll. Tanpa
   pseudo-element, tanpa teks ganda, tanpa mask.

   Yang diambil dari Osmo dan TIDAK diubah:
   - type: "words, chars". Kata tetap unit pembungkus baris, jadi tidak ada
     kata yang patah di tengah saat ganti baris. Yang dianimasikan char-nya.
   - autoSplit + onSplit yang mengembalikan gsap.context. SplitText memecah
     ulang saat resize atau saat webfont selesai dimuat, dan context lama
     dibersihkan sendiri oleh GSAP. Ini yang membuatnya aman di responsive.
   - ease linear, supaya sapuannya persis mengikuti posisi scroll.

   Yang ditambahkan untuk theme ini:
   - Mendaftar lewat FSL.motion.add, jadi ikut jalan ulang pada
     shopify:section:load dan ikut pembersihan trigger yatim.
   - Mati di Theme Editor dan saat prefers-reduced-motion.
   - Bail diam kalau gsap atau SplitText tidak ada. Tweennya "from", jadi
     keadaan akhir alaminya adalah teks penuh. Setiap jalur gagal berakhir
     dengan teks terbaca penuh, bukan teks redup yang tersangkut.
   - Flag dataset supaya satu elemen tidak pernah dipecah dua kali. */
(function () {
  var ns = window.FSL = window.FSL || {};
  var M = ns.motion;
  if (!M || !M.add) { return; }

  M.add(function (scope) {
    var gsap = M.gsap;
    var Split = window.SplitText;
    if (!gsap || !Split) { return; }
    if (M.inEditor || M.reduceMotion) { return; }

    var nodes = (scope || document).querySelectorAll('[data-highlight-text]');

    for (var i = 0; i < nodes.length; i++) {
      (function (el) {
        if (el.dataset.fslHighlighted === '1') { return; }
        el.dataset.fslHighlighted = '1';

        var start   = el.getAttribute('data-highlight-scroll-start') || 'top 90%';
        var end     = el.getAttribute('data-highlight-scroll-end')   || 'center 40%';
        var faded   = parseFloat(el.getAttribute('data-highlight-fade'));
        var stagger = parseFloat(el.getAttribute('data-highlight-stagger'));
        if (isNaN(faded))   { faded = 0.2; }
        if (isNaN(stagger)) { stagger = 0.1; }

        new Split(el, {
          type: 'words, chars',
          autoSplit: true,
          onSplit: function (self) {
            return gsap.context(function () {
              gsap.timeline({
                scrollTrigger: {
                  trigger: el,
                  start: start,
                  end: end,
                  scrub: true
                }
              }).from(self.chars, {
                autoAlpha: faded,
                stagger: stagger,
                ease: 'linear'
              });
            });
          }
        });
      })(nodes[i]);
    }
  });
})();
